const React = require('react');

module.exports = ({className, ...props}) => (
  <div className={`w1/4 w@m mt29 ph5` + (className ? ` ${className}` : '')} {...props} />
);
